import { getPokusValueFromLS } from '../pages/cabsPokus';
import { isMobile, isSSR } from './commonUtils';
import { trackRouteTemplateEvent } from './omnitureTracking';

const SEM_VALUE = 'SEM';

const hasModalInUrl = (): boolean => {
  if (isSSR()) return false;
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('modal') === 'login';
};

const hasSEMInUrl = (): boolean => {
  if (isSSR()) return false;
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('source');
  const cmp = searchParams.get('cmp');
  return Boolean(source?.includes(SEM_VALUE)) || Boolean(cmp?.includes(SEM_VALUE));
};

export const shouldAutoOpenLoginModal = (): boolean => {
  if (isSSR()) return false;
  
  try {
    const modalShown = sessionStorage.getItem('loginModalShown');
    if (modalShown === 'true') {
      return false;
    }
  } catch (error) {
    console.warn('Error checking session storage:', error);
  }

  const hasModal = hasModalInUrl();
  
  if (hasModal) {
    try {
      sessionStorage.setItem('loginModalShown', 'true');
    } catch (error) {
      console.warn('Error setting session storage:', error);
    }
  }
  
  const deviceType = isMobile() ? 'Mweb' : 'Dweb';
  trackRouteTemplateEvent(hasModal ? `${deviceType}-Cabs_SEO_login_nudge_shown` : `${deviceType}-Cabs_SEO_login_nudge_not_shown`);
  return hasModal;
};

export const updateUrlWithModal = (): void => {

  if (isSSR()) return;

  try {
    if (typeof window === 'undefined' || 
        !window.location || 
        !window.history || 
        typeof URL === 'undefined' ||
        typeof localStorage === 'undefined') {
      return;
    }

    if (typeof URLSearchParams === 'undefined') {
      return;
    }

    if (getPokusValueFromLS('Login_Nudge', 0) === 1 && !hasModalInUrl() && hasSEMInUrl()) {
      const url = new URL(window.location.href);
      url.searchParams.set('modal', 'login');
      window.history.replaceState({}, '', url.toString());
    }
  } catch (error) {
    console.warn('Error in updateUrlWithModal:', error);
  }
};
